import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconApp } from '@redteclab/icons'

import { Button } from 'base-ui'

import { StaticImage } from '../../../../../../image'
import AppQrCode from '../../../images/buy-box-qr.png'
import { RX_PDP_APP_VIEWPORT_URL } from '../../../rxPdpAppRedemptionLinks'
import { useRxPdpAppImpression } from '../../../useRxPdpAppImpression'
import { useRxPdpAppRedemptionTracking } from '../../../useRxPdpAppRedemptionTracking'

import styles from './AppDownloadBanner.module.css'

export const AppDownloadBanner: FC = () => {
  const tracking = useRxPdpAppRedemptionTracking()
  const mobileRef = useRxPdpAppImpression({
    action: 'app_cta_impression',
    placement: 'buy-box',
  })
  const desktopRef = useRxPdpAppImpression({
    action: 'qr_impression',
    placement: 'buy-box',
  })

  return (
    <>
      <div className="tablet:hidden" ref={mobileRef}>
        <Button<'a'>
          className="w-full"
          href={RX_PDP_APP_VIEWPORT_URL}
          onClick={() =>
            tracking?.track({ action: 'app_cta_click', placement: 'buy-box' })
          }
          size="large"
          slots={{ root: 'a' }}
          startIcon={<IconApp />}
        >
          <FormattedMessage id="rxPdpAppActivation.app.cta" />
        </Button>
      </div>
      <div className="hidden tablet:block" ref={desktopRef}>
        <div className={styles['app-download-banner__qr-card']}>
          <span className={styles['app-download-banner__qr-frame']}>
            <StaticImage alt="" aria-hidden src={AppQrCode} />
          </span>
          <span className="min-w-0 space-y-2">
            <strong className="block text-l font-medium">
              <FormattedMessage id="rxPdpAppActivation.qr.title" />
            </strong>
            <span className="block text-s">
              <FormattedMessage id="rxPdpAppActivation.qr.description" />
            </span>
          </span>
        </div>
      </div>
    </>
  )
}
